import { Navigate, Route, Routes } from "react-router";
import { AppShell } from "./components/AppShell";
import { Skeleton } from "./components/ui";
import { useAccounts } from "./lib/queries";
import { useSession } from "./lib/session";
import { Ajustes, PrimeiroUso } from "./screens/Ajustes";
import { Arquivadas } from "./screens/Arquivadas";
import { Cartao } from "./screens/Cartao";
import { Categorias } from "./screens/Categorias";
import { Conta } from "./screens/Conta";
import { Contas } from "./screens/Contas";
import { Familia } from "./screens/Familia";
import { Fluxo } from "./screens/Fluxo";
import { Hoje } from "./screens/Hoje";
import { Lancar } from "./screens/Lancar";
import { Login } from "./screens/Login";
import { Planejado } from "./screens/Planejado";
import { NovaRecorrencia, NovoParcelamento } from "./screens/Planejar";

export function App() {
  const { state } = useSession();

  if (state === "carregando")
    return (
      <div className="app">
        <Skeleton lines={5} />
      </div>
    );
  if (state === "fora") return <Login />;

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/hoje" element={<Guard><Hoje /></Guard>} />
        <Route path="/fluxo" element={<Guard><Fluxo /></Guard>} />
        <Route path="/contas" element={<Guard><Contas /></Guard>} />
        {/* Sem Guard de propósito: quem arquivou TODAS as contas cairia no primeiro uso e
            ficaria sem caminho nenhum de volta para as que arquivou. */}
        <Route path="/contas/arquivadas" element={<Arquivadas />} />
        <Route path="/contas/cartao/:id" element={<Guard><Cartao /></Guard>} />
        <Route path="/contas/conta/:id" element={<Guard><Conta /></Guard>} />
        <Route path="/planejado" element={<Guard><Planejado /></Guard>} />
        {/* As folhas abrem por cima da própria tela, como o Lançar faz com a Hoje. */}
        <Route
          path="/planejado/nova-recorrencia"
          element={<Guard><Planejado /><NovaRecorrencia /></Guard>}
        />
        <Route
          path="/planejado/novo-parcelamento"
          element={<Guard><Planejado /><NovoParcelamento /></Guard>}
        />
        {/* Editar é a MESMA folha de criar, com o registro carregado: dois formulários para
            a mesma coisa divergem com o tempo, e aqui o que diverge é o número. */}
        <Route
          path="/planejado/recorrencia/:id"
          element={<Guard><Planejado /><NovaRecorrencia /></Guard>}
        />
        <Route
          path="/planejado/parcelamento/:id"
          element={<Guard><Planejado /><NovoParcelamento /></Guard>}
        />
        <Route path="/ajustes" element={<Ajustes />} />
        <Route path="/ajustes/familia" element={<Familia />} />
        <Route path="/ajustes/categorias" element={<Categorias />} />
        {/* /lancar também passa pelo Guard: sem nenhuma conta, o "+" abria a folha com
            "Sai de" vazio e o botão desabilitado para sempre, mostrando um saldo de
            R$ 0,00 que não existia. É o botão mais visível do app e o primeiro que um
            usuário novo toca. */}
        <Route path="/lancar" element={<Guard><Hoje /><Lancar /></Guard>} />
        <Route path="*" element={<Navigate to="/hoje" replace />} />
      </Route>
    </Routes>
  );
}

/** Sem nenhuma conta, o painel não tem o que medir: manda para o primeiro uso. */
function Guard({ children }: { children: React.ReactNode }) {
  const { data, isPending } = useAccounts();
  if (isPending) return <Skeleton lines={5} />;
  if ((data ?? []).length === 0) return <PrimeiroUso />;
  return <>{children}</>;
}
